import React, { useState } from 'react';
import '../../css/Login.css';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';
import { auth } from '../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // NEW

    const handleReset = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true); // Start loading

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('Reset email sent! Check your inbox.');
        } catch (err) {
            setError('Failed to send reset email. Please check your email address.');
            console.error(err.message);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="Logo" className="login-logo" />
                <h2 className="login-title">Forgot Password</h2>
                <p className="login-subtitle">
                    Enter your email to receive password reset instructions.
                </p>

                <form className="login-form" onSubmit={handleReset}>
                    <input
                        type="email"
                        placeholder="Enter your email"
                        className="login-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    {message && <p className="success-message">{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? (
                            <div className="spinner"></div> // Show spinner
                        ) : (
                            'Send Reset Link'
                        )}
                    </button>
                </form>

                <div className="login-footer">
                    <p>
                        Remember your password?{' '}
                        <Link to="/login" className="login-link">Back to Login</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
